import React, { Component } from "react";
import { Link } from "react-router-dom";
import Moment from "moment";
import "moment/locale/es";
import Firebase from "firebase";
import Connector from "../../data/Connector";
import Cal from "../../helper/Calendar";
import HelperClients from "../../helper/Clients";
import HelperBusiness from "../../helper/Business";
import HelperPage from "../../helper/Page";
import * as ROUTES from "../../constants/routes";
import EventEmitter from "../../helper/Emitter";
import WidgetOverview from "../../components/Widgets/overview";
import WidgetActions from "../../components/Widgets/actions";
import ListHeader from "../../components/List/header";
import ListEmpty from "../../components/List/empty";
import ListEmptySearch from "../../components/List/empty-search";
import ModalMessageSimple from "../../components/Modals/message-simple";
import ModalMessageDouble from "../../components/Modals/message-double";
import ModalItems from "../../components/Modals/items";
import ModalTrial from "../../components/Modals/trial";
import ModalVideo from "../../components/Modals/video";
import Navigation from "../../components/Navigation";
import Header from "../../components/Headers/header";
import Tour from "../../components/Message/tour";
import { withTranslation } from "react-i18next";
import lang from "i18next";
import { AuthUserContext, withAuthorization } from "../../components/Session";

class ClientsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sessions: global.sessions,
      archive: global.archive,
      sessionsTraining: global.sessionsTraining,
      archiveTraining: global.archiveTraining,
      clients: global.clients,
      clientsInactive: global.clientsInactive,
      clientsTrial: [],
      groups: global.clientGroups,
      currentGroup: "",
      dateRange: global.dateRange,
      list: "cards",
      search: "",
      searchInactive: "",
      order: "name",
      maxClients: global.maxClients,
      clientType: "clients",
      client: null,
      trialDate: Moment().add(7, "days").format("X"),
      trialer: null,
      invitees: 0,
      bookings: [],
      showModalMessage: false,
      showModalInvite: false,
      showModalNotes: false,
      showModalBookings: false,
      showModalVideo: false,
      showModalDelete: false,
      reactivateOption: "",
    };
  }

  componentDidMount() {
    HelperPage.initialize("Clients - PT Mate", ROUTES.CLIENTS);
    this._isMounted = true;

    if (global.message !== "") {
      /*if(global.message === lang.t('messaging:message.clientcreated') && global.userSubStatus === 'trialing' && global.clients.length === 1) {
        setTimeout(() => {
          if(global.userTypes.indexOf('pt') !== -1) {
            window.Intercom('startTour', '320224')
          } else if(global.userTypes.indexOf('group') !== -1 && global.userTypes.indexOf('pt') === -1) {
            window.Intercom('startTour', '320225')
          } else {
            window.Intercom('startTour', '320230')
          }
          global.message = ''
        }, 1100);
      }*/
      setTimeout(() => {
        EventEmitter.dispatch("showMessage", global.message);
        global.message = "";
      }, 300);
    }

    EventEmitter.subscribe("clientsLoaded", (event) => this.updateMax());
    EventEmitter.subscribe("sessionsLoaded", (event) => this.setSessions());
    EventEmitter.subscribe("archiveLoaded", (event) =>
      this.setState({ archive: global.archive }),
    );
    EventEmitter.subscribe("clientsLoaded", (event) => this.setClients());
    EventEmitter.subscribe("locationSet", (event) => this.setClients());
    if (this.state.sessionsTraining.length === 0) {
      setTimeout(() => {
        this.updateTraining();
      }, 5000);
    }
    if (!global.updatingRec) {
      Connector.checkRecurring();
    }
    EventEmitter.subscribe("groupsLoaded", (event) =>
      this.setState({
        groups: global.clientGroups,
      }),
    );

    this.setClients();
  }

  componentWillUnmount() {
    this._isMounted = false;
    EventEmitter.unsubscribe("clientsLoaded", () => {});
    EventEmitter.unsubscribe("sessionsLoaded", () => {});
    EventEmitter.unsubscribe("archiveLoaded", () => {});
    EventEmitter.unsubscribe("clientsLoaded", () => {});
    EventEmitter.unsubscribe("locationSet", () => {});
  }

  setClients() {
    if (this._isMounted) {
      var tmp1 = [];
      var tmp2 = [];
      var tmp11 = [];
      var tmp21 = [];
      for (var item of global.clients) {
        if (item.subscriptions.length === 0) {
          tmp1.push(item);
        } else {
          var trial = false;
          for (var sub of item.subscriptions) {
            if (
              sub.id === "trial" &&
              global.userStripeConnect !== "" &&
              global.userStripeConnect !== undefined
            ) {
              trial = true;
            }
          }
          if (trial) {
            tmp2.push(item);
          } else {
            tmp1.push(item);
          }
        }
      }

      // Check locations
      if (global.loc !== "") {
        for (var loc of global.locations) {
          if (loc.id === global.loc && loc.data.clients !== undefined) {
            for (var t1 of tmp1) {
              if (loc.data.clients.indexOf(t1.id) !== -1) {
                tmp11.push(t1);
              }
            }
            for (var t2 of tmp2) {
              if (loc.data.clients.indexOf(t2.id) !== -1) {
                tmp21.push(t2);
              }
            }
          }
        }
      } else {
        tmp11 = tmp1;
        tmp21 = tmp2;
      }

      this.setState({
        clients: tmp11,
        clientsInactive: global.clientsInactive,
        clientsTrial: tmp21,
      });
    }
  }

  setSessions() {
    if (this._isMounted) {
      var tmp = [];
      for (var item of global.sessions) {
        tmp.push(item);
      }
      this.setState({
        sessions: tmp,
      });
    }
  }

  updateTraining() {
    this.setState({
      sessionsTraining: global.sessionsTraining,
      archiveTraining: global.archiveTraining,
    });
    if (this.state.sessionsTraining.length === 0) {
      setTimeout(() => {
        this.updateTraining();
      }, 5000);
    }
  }

  updateMax() {
    if (this._isMounted) {
      this.setState({
        clients: global.clients,
        clientsInactive: global.clientsInactive,
        maxClients: global.maxClients,
      });
    }
  }

  getInactiveDate(item) {
    if (!item.history) return null;
    let inactiveDate = null;
    for (var note of item.history) {
      if (note.data && note.data.title && note.data.title.toLowerCase().startsWith("inactiv")) {
        inactiveDate = Moment(note.data.date, "DD/MM/YYYY HH:mm");
      }
    }
    return inactiveDate;
  }

  async activateClients() {
    const { reactivateOption } = this.state;
    if (reactivateOption === "") {
      EventEmitter.dispatch(
        "showMessageError",
        lang.t("messaging:message.selecttimeframeerror"),
      );
      return;
    }
    
    this.setState({ loadingReactivate: true });
    await new Promise(resolve => setTimeout(resolve, 100));

    const now = Moment();
    let matchCount = 0;
    let promises = [];

    for (var item of this.state.clientsInactive) {
      let shouldActivate = false;

      if (reactivateOption === "all") {
        shouldActivate = true;
      } else {
        const inactiveDate = this.getInactiveDate(item);
        if (inactiveDate) {
          if (reactivateOption === "today") {
            shouldActivate = inactiveDate.isSame(now, "day");
          } else if (reactivateOption === "yesterday") {
            const yesterday = Moment().subtract(1, "day");
            shouldActivate = inactiveDate.isSame(yesterday, "day");
          } else if (reactivateOption === "week") {
            const sevenDaysAgo = Moment().subtract(7, "days");
            shouldActivate = inactiveDate.isAfter(sevenDaysAgo);
          }
        }
      }

      if (shouldActivate) {
        matchCount++;
        promises.push(
          Firebase.database()
            .ref("/clients/" + global.uid + "/" + item.id)
            .update({
              active: true,
            })
        );
        
        if (promises.length >= 20) {
          try {
            await Promise.all(promises);
          } catch(err) { console.error(err); }
          promises = [];
        }
      }
    }

    if (promises.length > 0) {
      try {
        await Promise.all(promises);
      } catch(err) { console.error(err); }
    }
    
    this.setState({ loadingReactivate: false });
    if (matchCount > 0) {
      EventEmitter.dispatch(
        "showMessage",
        lang.t("messaging:message.clientsreactivated"),
      );
    } else {
      EventEmitter.dispatch(
        "showMessageError",
        lang.t("messaging:message.nomembersfound"),
      );
    }
  }

  toggleClientSelection(id) {
    let selected = this.state.selectedClients ? [...this.state.selectedClients] : [];
    if (selected.includes(id)) {
      selected = selected.filter(clientId => clientId !== id);
    } else {
      selected.push(id);
    }
    this.setState({ selectedClients: selected });
  }

  async deactivateSelectedClients() {
    if (!this.state.selectedClients || this.state.selectedClients.length === 0) return;

    this.setState({ loadingBulkDeactivate: true });
    await new Promise(resolve => setTimeout(resolve, 100));

    let promises = [];
    for (const clientId of this.state.selectedClients) {
      promises.push(
        Firebase.database()
          .ref("/clients/" + global.uid + "/" + clientId)
          .update({
            active: false,
          })
      );
      
      if (promises.length >= 20) {
        try {
          await Promise.all(promises);
        } catch(err) { console.error(err); }
        promises = [];
      }
    }

    if (promises.length > 0) {
      try {
        await Promise.all(promises);
      } catch(err) { console.error(err); }
    }
    
    this.setState({ loadingBulkDeactivate: false, selectedClients: [] });
    EventEmitter.dispatch(
      "showMessage",
      lang.t("messaging:message.clientsdeleted"),
    );
  }

  async deactivateInactiveClients() {
    const { deactivateOption, deactivateStartDate, deactivateEndDate } = this.state;
    if (deactivateOption === "") {
      EventEmitter.dispatch("showMessageError", lang.t("messaging:message.selecttimeframeerror"));
      return;
    }
    if (deactivateOption === "custom" && (!deactivateStartDate || !deactivateEndDate)) {
      EventEmitter.dispatch("showMessageError", "Please select a valid start and end date");
      return;
    }

    this.setState({ loadingDeactivate: true });
    await new Promise(resolve => setTimeout(resolve, 100));
    
    let matchCount = 0;
    let promises = [];

    for (let i = 0; i < this.state.clients.length; i++) {
      let item = this.state.clients[i];
      
      let isInactive = false;
      if (deactivateOption === "week") {
        if (!item.lastSession || Moment(item.lastSession, "DD/MM/YYYY HH:mm") < Moment().subtract(7, "days")) {
          isInactive = true;
        }
      } else if (deactivateOption === "month") {
        if (!item.lastSession || Moment(item.lastSession, "DD/MM/YYYY HH:mm") < Moment().subtract(30, "days")) {
          isInactive = true;
        }
      } else if (deactivateOption === "custom") {
        let start = Moment(deactivateStartDate).startOf('day');
        let end = Moment(deactivateEndDate).endOf('day');
        if (!item.lastSession || (Moment(item.lastSession, "DD/MM/YYYY HH:mm") >= start && Moment(item.lastSession, "DD/MM/YYYY HH:mm") <= end)) {
          isInactive = true;
        }
      }

      if (isInactive) {
        matchCount++;
        promises.push(
          Firebase.database()
            .ref("/clients/" + global.uid + "/" + item.id)
            .update({
              active: false,
            })
        );
        
        if (promises.length >= 20) {
          try {
            await Promise.all(promises);
          } catch(err) { console.error(err); }
          promises = [];
        }
      }
    }

    if (promises.length > 0) {
      try {
        await Promise.all(promises);
      } catch(err) { console.error(err); }
    }
    
    this.setState({ loadingDeactivate: false });
    if (matchCount > 0) {
      EventEmitter.dispatch(
        "showMessage",
        lang.t("messaging:message.clientsdeleted"),
      );
    } else {
      EventEmitter.dispatch(
        "showMessageError",
        lang.t("messaging:message.noclientstodeactivate"),
      );
    }
  }

  deleteInactiveClients() {
    this.hideModals();
    for (var item of this.state.clientsInactive) {
      Firebase.database()
        .ref("/clients/" + global.uid + "/" + item.id)
        .remove();
    }
    setTimeout(() => {
      EventEmitter.dispatch(
        "showMessage",
        lang.t("messaging:message.inactiveclientsdeleted"),
      );
    }, 500);
  }

  // Overview Calculations ------------------------------------------------------------

  getActiveClients() {
    var minDate = Moment(Cal.getDateRange(), "X");
    var clients = [];
    for (var item of this.state.sessions) {
      var add = false;
      if (
        this.state.dateRange === "7days" ||
        this.state.dateRange === "30days" ||
        this.state.dateRange === "60days"
      ) {
        if (
          Moment(item.data.date, "DD/MM/YYYY HH:mm") > minDate &&
          Moment(item.data.date, "DD/MM/YYYY HH:mm") < Moment()
        ) {
          add = true;
        }
      } else if (this.state.dateRange === "month") {
        if (
          Moment(item.data.date, "DD/MM/YYYY HH:mm").format("MM/YYYY") ===
            Moment().format("MM/YYYY") &&
          Moment(item.data.date, "DD/MM/YYYY HH:mm") < Moment()
        ) {
          add = true;
        }
      } else if (this.state.dateRange === "week") {
        if (
          Moment(item.data.date, "DD/MM/YYYY HH:mm") >
            Moment().startOf("week") &&
          Moment(item.data.date, "DD/MM/YYYY HH:mm") < Moment()
        ) {
          add = true;
        }
      } else {
        if (Moment(item.data.date, "DD/MM/YYYY HH:mm").format("X") < Moment()) {
          add = true;
        }
      }
      if (global.loc !== "" && item.data.location !== global.loc) {
        add = false;
      }
      if (add && clients.indexOf(item.data.client) === -1) {
        if (!item.data.group) {
          clients.push(item.data.client);
        } else {
          if (item.data.clients !== undefined) {
            for (var client of item.data.clients) {
              if (clients.indexOf(client) === -1) {
                clients.push(client);
              }
            }
          }
        }
      }
    }
    return clients.length;
  }

  getActiveDifference(type) {
    var arr = ["", "+0"];
    var today = Moment().format("X");
    var minDate = Cal.getDateRangeDiff()[0];
    var minDate2 = Cal.getDateRangeDiff()[1];
    var prevDate = Cal.getDateRangeDiff()[2];
    var clients1 = [];
    var clients2 = [];

    for (var item of this.state.sessions) {
      var add1 = false;
      var add2 = false;
      var idate = Moment(item.data.date, "DD/MM/YYYY HH:mm").format("X");
      if (
        this.state.dateRange === "7days" ||
        this.state.dateRange === "30days" ||
        this.state.dateRange === "60days"
      ) {
        if (idate > minDate && idate < today) {
          add1 = true;
        }
        if (idate > prevDate && idate < minDate2) {
          add2 = true;
        }
      } else if (this.state.dateRange === "month") {
        if (
          Moment(item.data.date, "DD/MM/YYYY HH:mm").format("MM/YYYY") ===
            Moment().format("MM/YYYY") &&
          Moment(item.data.date, "DD/MM/YYYY HH:mm") < Moment()
        ) {
          add1 = true;
        }
        if (
          Moment(item.data.date, "DD/MM/YYYY HH:mm").format("MM/YYYY") ===
          Moment().add(-1, "month").format("MM/YYYY")
        ) {
          add2 = true;
        }
      } else if (this.state.dateRange === "week") {
        idate = Moment(item.data.date, "DD/MM/YYYY HH:mm").format("X");
        if (idate > minDate && idate < today) {
          add1 = true;
        }
        if (idate > prevDate && idate < minDate2) {
          add2 = true;
        }
      }
      if (global.loc !== "" && item.data.location !== global.loc) {
        add1 = false;
        add2 = false;
      }

      if (add1 && clients1.indexOf(item.data.client) === -1) {
        if (!item.data.group) {
          clients1.push(item.data.client);
        } else {
          if (item.data.clients !== undefined) {
            for (var client of item.data.clients) {
              if (clients1.indexOf(client) === -1) {
                clients1.push(client);
              }
            }
          }
        }
      }
      if (add2 && clients2.indexOf(item.data.client) === -1) {
        if (!item.data.group) {
          clients2.push(item.data.client);
        } else {
          if (item.data.clients !== undefined) {
            for (var client2 of item.data.clients) {
              if (clients2.indexOf(client2) === -1) {
                clients2.push(client2);
              }
            }
          }
        }
      }
    }

    arr[1] = String(clients1.length - clients2.length);
    if (clients2.length < clients1.length) {
      arr[0] = "green";
      arr[1] = "+" + arr[1];
    } else if (clients2.length > clients1.length) {
      arr[0] = "red";
    }

    if (type === "badge") {
      if (this.state.dateRange !== "60days") {
        return (
          <div
            className={"badge " + arr[0]}
            title={lang.t("overview:changecompared")}
          >
            {arr[1]}
          </div>
        );
      } else {
        return (
          <div className={"badge"} title={lang.t("overview:changecompared")}>
            N/A
          </div>
        );
      }
    } else {
      return clients2.length;
    }
  }

  setView(type) {
    this.setState({ list: type });
  }

  setGroup(event) {
    this.setState(
      {
        currentGroup: event.target.value,
      },
      (then) => {
        this.combineFilters();
      },
    );
  }

  filterClients = (event) => {
    this.setState(
      {
        search: event.target.value,
      },
      (then) => {
        this.combineFilters();
      },
    );
  };

  combineFilters() {
    var tmp = global.clients;
    var tmp2 = [];
    if (this.state.search !== "") {
      tmp = [];
      for (var item of global.clients) {
        if (
          item.data.name
            .toLowerCase()
            .indexOf(this.state.search.toLowerCase()) !== -1
        ) {
          tmp.push(item);
        }
      }
    }

    if (this.state.currentGroup !== "") {
      var clients = [];
      for (var gr of this.state.groups) {
        if (gr.id === this.state.currentGroup) {
          clients = gr.data.clients;
        }
      }
      for (var tc of tmp) {
        for (var cc of clients) {
          if (cc === tc.id) {
            tmp2.push(tc);
          }
        }
      }
    } else {
      tmp2 = tmp;
    }
    this.setState({ clients: tmp2 });
  }

  filterClientsInactive = (event) => {
    this.setState(
      {
        searchInactive: event.target.value,
      },
      (then) => {
        var tmp = global.clientsInactive;
        if (this.state.searchInactive !== "") {
          tmp = [];
          for (var item of global.clientsInactive) {
            if (
              item.data.name
                .toLowerCase()
                .indexOf(this.state.searchInactive.toLowerCase()) !== -1
            ) {
              tmp.push(item);
            }
          }
        }
        this.setState({
          clientsInactive: tmp,
        });
      },
    );
  };

  // Client Info ------------------------------------------------------------

  getSessionsClient(id) {
    var count = 0;
    for (var item of this.state.sessions) {
      if (item.data.client === id) {
        count++;
      }
    }
    return count;
  }

  getGroupClient(id) {
    var count = 0;
    for (var item of this.state.sessions) {
      if (item.data.clients !== undefined) {
        if (item.data.clients.indexOf(id) !== -1) {
          count++;
        }
      }
    }
    return count;
  }

  selectClient(id) {
    global.currentClient = id;
  }

  getDebit(item) {
    var label = lang.t("clients:label.nomembership");
    if (item.subscriptions.length > 0) {
      label = lang.t("clients:label.activemembership");
      for (var sub of item.subscriptions) {
        if (sub.id === "trial") {
          label = lang.t("clients:label.freetrial");
        }
      }
    }
    if (item.data.parent !== undefined && item.data.parent !== "") {
      for (var cl of global.clients) {
        if (cl.id === item.data.parent) {
          label = lang.t("clients:label.managedby") + " " + cl.data.name;
        }
      }
    }
    if (HelperBusiness.getRole("assistant,assistant2")) {
      label =
        lang.t("clients:label.dob2") +
        ": " +
        Moment(item.data.birth, "DD/MM/YYYY")
          .locale(lang.language)
          .format("D MMM YYYY");
    }
    return label;
  }

  // Modals ------------------------------------------------------------

  showModalNotes(e, client) {
    e.stopPropagation();
    e.preventDefault();
    this.setState({
      showModalNotes: true,
      client: client,
    });
  }

  showModalInvite() {
    var num = 0;
    for (var cl of global.clients) {
      if (cl.data.uid === "" && cl.data.email !== "") {
        num++;
      }
    }
    this.setState({
      invitees: num,
      showModalInvite: true,
    });
  }

  showModalTrial(client) {
    var tmp2 = Moment().add(7, "days");
    for (var item of client.subscriptions) {
      if (item.data.name === "Free trial") {
        tmp2 = Moment(item.data.next, "X");
      }
    }
    this.setState({
      showModalTrial: true,
      trialDate: Moment(tmp2).format("X"),
      trialer: client,
    });
  }

  showModalBookings(e, client) {
    e.stopPropagation();
    e.preventDefault();
    var list = [];
    for (var item of this.state.sessions) {
      if (
        Moment(item.data.date, "DD/MM/YYYY HH:mm") > Moment() &&
        item.data.clients !== undefined
      ) {
        if (item.data.group && item.data.clients.indexOf(client.id) !== -1) {
          list.push({
            data: {
              type: lang.t("clients:label.bookedin"),
              name:
                item.data.client === ""
                  ? lang.t("clients:label.groupsession")
                  : item.data.client,
              timestamp: item.data.timestamp,
              link: "/calendar/group-session/" + item.id,
            },
          });
        }
      }
      if (
        Moment(item.data.date, "DD/MM/YYYY HH:mm") > Moment() &&
        !item.data.group
      ) {
        if (item.data.client === client.id) {
          list.push({
            data: {
              type: lang.t("clients:label.scheduled"),
              name: lang.t("clients:label.11session"),
              timestamp: item.data.timestamp,
              link: "/calendar/session/" + item.id,
            },
          });
        }
      }
    }
    this.setState({
      showModalBookings: true,
      client: client,
      bookings: list,
    });
  }

  hideModals() {
    this.setState({
      showModalMessage: false,
      showModalNotes: false,
      showModalInvite: false,
      showModalTrial: false,
      showModalBookings: false,
      showModalVideo: false,
      showModalDelete: false,
    });
  }

  modalClick() {
    this.hideModals();
    this.props.history.push(ROUTES.SUBSCRIPTION);
  }

  sendInvites() {
    var business = global.userBusiness;
    if (global.userBusiness === "") {
      business = global.userName;
    }
    this.hideModals();
    EventEmitter.dispatch(
      "showMessage",
      lang.t("messaging:message.clientsinvited"),
    );
    for (var cl of global.clients) {
      if (cl.data.uid === "" && cl.data.email !== "") {
        if (
          cl.data.email.indexOf("@") !== -1 &&
          cl.data.email.indexOf(".") !== -1 &&
          cl.data.email.indexOf(" ") === -1 &&
          cl.data.email !== "" &&
          cl.data.email !== undefined
        ) {
          var callFunction1 =
            Firebase.functions().httpsCallable("sendClientInviteV2");
          callFunction1({
            email: cl.data.email,
            name: global.userName,
            user: global.uidUser,
            business: business,
            phone: global.userPhone,
            color: HelperPage.getEmailColor(),
            image: HelperPage.getEmailImage(),
          }).then(function (result) {});

          if (cl.data.phone !== "") {
            Firebase.database()
              .ref("/connect/" + cl.id)
              .update({
                phone: cl.data.phone,
                name: global.userName,
                client: cl.id,
                space: global.uid,
                email: cl.data.email,
              });
          }
        }
      }
    }
  }

  updateTrial() {
    this.hideModals();
    var edate = this.state.trialDate;
    if (Moment(edate, "X") < Moment()) {
      edate = Moment().add(1, "days").format("X");
    }
    Firebase.database()
      .ref(
        "/clients/" +
          global.uid +
          "/" +
          this.state.trialer.id +
          "/subscriptions/trial",
      )
      .update({
        next: parseInt(edate),
      })
      .then(() => {
        EventEmitter.dispatch(
          "showMessage",
          lang.t("messaging:message.trialextended"),
        );
      })
      .catch((error) => {
        EventEmitter.dispatch("showMessageError", error.message);
      });
  }

  cancelTrial() {
    this.hideModals();
    Firebase.database()
      .ref(
        "/clients/" +
          global.uid +
          "/" +
          this.state.trialer.id +
          "/subscriptions/trial",
      )
      .remove();
    EventEmitter.dispatch(
      "showMessage",
      lang.t("messaging:message.clientconverted"),
    );
  }

  cancelDeleteClient() {
    this.hideModals();
    Firebase.database()
      .ref("/clients/" + global.uid + "/" + this.state.item.id)
      .update({
        deleted: true,
      });
    EventEmitter.dispatch(
      "showMessage",
      lang.t("messaging:message.clientdeleted"),
    );
  }

  cancelDeleteTrial() {
    this.hideModals();
    if (this.state.trialer) {
      Firebase.database()
        .ref("/clients/" + global.uid + "/" + this.state.trialer.id)
        .update({
          deleted: true,
        });
      EventEmitter.dispatch(
        "showMessage",
        lang.t("messaging:message.clientdeleted"),
      );
    }
  }

  // Display stuff ------------------------------------------------------------

  renderListheaderSelect() {
    if (
      this.state.groups.length > 0 &&
      HelperBusiness.getRoleIncl("trainer,admin")
    ) {
      var list = this.state.groups;
      list.sort((a, b) => a.data.name.localeCompare(b.data.name));
      return (
        <select
          className="light rgt ml-30"
          onChange={(event) => this.setGroup(event)}
          value={this.state.currentGroup}
        >
          <option value="">{lang.t("clients:label.allclientgroups")}</option>
          {list.map((item) => (
            <option value={item.id} key={item.id}>
              {item.data.name}
            </option>
          ))}
        </select>
      );
    }
  }

  renderListheader() {
    return (
      <div className="listheader col-12 clear mb-20-992">
        <div className="pt-10 lft">
          <ListHeader id="activeclients" number={this.state.clients.length} />
        </div>
        <div className="toggles ml-30">
          <div
            title={lang.t("clients:label.cardview")}
            className={
              this.state.list === "cards"
                ? "icontoggle cards active lft"
                : "icontoggle cards lft"
            }
            onClick={() => this.setView("cards")}
          ></div>
          <div
            title={lang.t("clients:label.listview")}
            className={
              this.state.list === "list"
                ? "icontoggle list active lft"
                : "icontoggle list lft"
            }
            onClick={() => this.setView("list")}
          ></div>
        </div>
        {this.renderListheaderSelect()}
        <input
          type="text"
          className="light search rgt"
          placeholder="Filter by name"
          value={this.state.search}
          onChange={(val) => this.filterClients(val)}
        />

        <div className="clear"></div>
      </div>
    );
  }

  renderStatus(item) {
    var label = lang.t("clients:label.familyaccount");
    if (item.data.restricted) {
      label = lang.t("clients:label.familyaccount");
    }
    if (item.data.uid === "") {
      if (item.data.parent === undefined || item.data.parent === "") {
        return (
          <span className="pill grey">
            {lang.t("clients:label.notconnected")}
          </span>
        );
      } else {
        return <span className="pill blue">{label}</span>;
      }
    } else {
      if (item.data.parent === undefined || item.data.parent === "") {
        if (item.data.linked !== undefined) {
          if (item.data.linked.length > 0) {
            return (
              <span className="pill green">
                {lang.t("clients:label.familymainaccount")}
              </span>
            );
          }
        } else {
          return (
            <span className="pill green">
              {lang.t("clients:label.connected")}
            </span>
          );
        }
      } else {
        return <span className="pill green">{label}</span>;
      }
    }
  }

  renderListClass(item) {
    var label = "col-4 col-6-1280";
    if (item.data.parent !== undefined && item.data.parent !== "") {
      label = "col-4 col-6-1280 family";
    }
    return label;
  }

  renderChild(item) {
    if (item.data.restricted) {
      return <span className="pill">{lang.t("clients:label.child")}</span>;
    }
  }

  renderGroups(client) {
    var groups = [];
    var items = false;
    for (var gr of global.clientGroups) {
      if (gr.data.clients !== undefined) {
        if (gr.data.clients.indexOf(client.id) !== -1) {
          items = true;
          groups.push({ name: gr.data.name, color: gr.data.color });
        }
      }
    }
    if (!items) {
      return <div className="groups"></div>;
    } else {
      return (
        <div className="groups">
          {groups.map((item) => (
            <div
              key={item.name}
              className={"bullet group lft " + item.color}
              title={item.name}
            ></div>
          ))}
        </div>
      );
    }
  }

  renderClients() {
    var list = this.state.clients;
    list.sort((a, b) => a.data.name.localeCompare(b.data.name));

    if (this.state.list === "cards") {
      return (
        <div>
          {list.map((item) => (
            <div className="col-2 col-3-1280" key={item.id}>
              <div className="box card clients highlight mb-20" style={{ position: "relative" }}>
                <Link
                  to={"/clients/" + item.id + "/overview"}
                  onClick={() => this.selectClient(item.id)}
                  style={{ display: "block", color: "inherit", textDecoration: "none" }}
                >
                  {this.renderGroups(item)}
                  <div className="clear"></div>
                  {HelperClients.getImage(item)}
                  <div className="sv-20"></div>
                  <h4 className="mb-10">
                    {item.data.name}
                    {HelperClients.getDotBirthday(item)}
                  </h4>
                  <p className="mb-10">
                    {lang.t("clients:label.phone")}:{" "}
                    {HelperClients.getPhone(item.data.phone)}
                    <br />
                    {this.getDebit(item)}
                  </p>
                  {this.renderStatus(item)}
                  <div className="sv-30"></div>
                  <button className="btn tertiary center small width-12">
                    {lang.t("common:button.viewdetails")}
                  </button>
                </Link>
                {true && (
                  <div 
                    style={{ position: "absolute", bottom: "15px", right: "15px", zIndex: 30, cursor: "pointer", padding: "10px" }} 
                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.toggleClientSelection(item.id); }}
                  >
                    <div style={{
                      width: "20px",
                      height: "20px",
                      border: "2px solid #ccc",
                      borderRadius: "3px",
                      backgroundColor: (this.state.selectedClients || []).includes(item.id) ? "#4caf50" : "transparent",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center"
                    }}>
                      {(this.state.selectedClients || []).includes(item.id) && <span style={{ color: "#fff", fontSize: "14px", lineHeight: "1" }}>✔</span>}
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
          <div className="col-2 col-3-1280">
            <button
              className="inline-add card mb-20"
              onClick={() => this.props.history.push(ROUTES.NEWCLIENT)}
            ></button>
          </div>
        </div>
      );
    } else {
      var list2 = list;
      for (var c1 of list2) {
        c1.name = c1.data.name;
        if (c1.data.parent !== undefined && c1.data.parent !== "") {
          for (var c2 of list) {
            if (c2.id === c1.data.parent) {
              c1.name = c2.data.name + "1";
            }
          }
        }
      }
      list2.sort((a, b) => a.name.localeCompare(b.name));
      return (
        <div>
          <div className="clear"></div>
          {list2.map((item) => (
            <div
              className={
                "box list simple highlight mb-10" +
                (item.data.parent !== undefined && item.data.parent !== ""
                  ? " family"
                  : "")
              }
              key={item.id}
            >
              {true && (
                <div className="lft pt-15 pl-15" style={{width: "40px"}} onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.toggleClientSelection(item.id); }}>
                  <div style={{
                    width: "20px",
                    height: "20px",
                    border: "2px solid #ccc",
                    borderRadius: "3px",
                    backgroundColor: (this.state.selectedClients || []).includes(item.id) ? "#4caf50" : "transparent",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "5px"
                  }}>
                    {(this.state.selectedClients || []).includes(item.id) && <span style={{ color: "#fff", fontSize: "14px", lineHeight: "1" }}>✔</span>}
                  </div>
                </div>
              )}
              <Link
                to={"/clients/" + item.id + "/overview"}
                onClick={() => this.selectClient(item.id)}
                style={{ width: true ? "calc(100% - 40px)" : "100%", float: "left" }}
              >
                <div className={this.renderListClass(item)}>
                  {HelperClients.getImage(item)}
                  <p className="lft">
                    <span className="lft">
                      <strong>{item.data.name}</strong> {this.renderChild(item)}
                    </span>
                    <div
                      className="icontoggle bookings lft"
                      onClick={(e) => this.showModalBookings(e, item)}
                      title={lang.t("clients:label.viewbookings")}
                    ></div>
                    <div
                      className="icontoggle notes lft"
                      onClick={(e) => this.showModalNotes(e, item)}
                      title={lang.t("clients:label.viewnotes")}
                    ></div>
                  </p>
                  {this.renderGroups(item)}
                  {HelperClients.getDotBirthday(item)}
                </div>
                <div className="col-2 center">
                  <p title={lang.t("clients:label.11sessions")}>
                    {Cal.getAmountClient(
                      this.state.sessions,
                      this.state.archive,
                      "sessions",
                      this.state.dateRange,
                      item.id,
                    )}{" "}
                    1:1
                  </p>
                </div>
                <div className="col-2 center">
                  <p title={lang.t("clients:label.groupsessions")}>
                    {Cal.getAmountClient(
                      this.state.sessions,
                      this.state.archive,
                      "group",
                      this.state.dateRange,
                      item.id,
                    )}{" "}
                    {lang.t("clients:label.group")}
                  </p>
                </div>
                <div className="col-2 center hide-1280">
                  <p title={lang.t("clients:label.trainingsessions")}>
                    {Cal.getAmountClient(
                      this.state.sessionsTraining,
                      this.state.archiveTraining,
                      "sessions",
                      this.state.dateRange,
                      item.data.uid,
                    )}{" "}
                    {lang.t("clients:label.training")}
                  </p>
                </div>
                <div className="col-2">
                  <button className="btn tertiary small rgt">
                    {lang.t("common:button.viewdetails")}
                  </button>
                </div>
              </Link>
            </div>
          ))}
          <button
            className="inline-add list mb-10"
            onClick={() => this.props.history.push(ROUTES.NEWCLIENT)}
          >
            {lang.t("clients:button.addanotherclient")}
          </button>
        </div>
      );
    }
  }

  renderExpiry(item) {
    var date = Moment();
    for (var sub of item.subscriptions) {
      if (sub.id === "trial") {
        date = Moment(sub.data.next, "X");
      }
    }
    if (Moment(date, "X") > Moment()) {
      if (Moment(date, "X") < Moment().add(2, "days")) {
        return (
          <p>
            {lang.t("clients:label.ends")}{" "}
            {Moment(date, "X").locale(lang.language).format("D MMM YYYY")}{" "}
            <span className="pill yellow">
              {lang.t("clients:label.endssoon")}
            </span>
          </p>
        );
      } else {
        return (
          <p>
            {lang.t("clients:label.ends")}{" "}
            {Moment(date, "X").locale(lang.language).format("D MMM YYYY")}
          </p>
        );
      }
    } else {
      return (
        <p>
          {lang.t("clients:label.ended")}{" "}
          {Moment(date, "X").locale(lang.language).format("D MMM YYYY")}{" "}
          <span className="pill red">{lang.t("clients:label.ended")}</span>
        </p>
      );
    }
  }

  renderTrialContent(item) {
    var date = Moment();
    for (var sub of item.subscriptions) {
      if (sub.id === "trial") {
        date = Moment(sub.data.next, "X");
      }
    }
    if (Moment(date, "X") > Moment()) {
      return (
        <Link
          to={"/clients/" + item.id + "/overview"}
          onClick={() => this.selectClient(item.id)}
        >
          <div className="col-5">
            {HelperClients.getImage(item)}
            <p className="lft">
              <strong>{item.data.name}</strong>
            </p>
            {HelperClients.getDotBirthday(item)}
          </div>
          <div className="col-5 center">{this.renderExpiry(item)}</div>
          <div className="col-2">
            <button className="btn tertiary small rgt">
              {lang.t("common:button.viewdetails")}
            </button>
          </div>
        </Link>
      );
    } else {
      return (
        <div onClick={() => this.showModalTrial(item)}>
          <div className="col-5 col-7-1280">
            {HelperClients.getImage(item)}
            <p className="lft">
              <strong>{item.data.name}</strong>
            </p>
            {HelperClients.getDotBirthday(item)}
          </div>
          <div className="col-5 col-3-1280 center">
            {this.renderExpiry(item)}
          </div>
          <div className="col-2">
            <button className="btn tertiary small rgt">
              {lang.t("common:button.manage")}
            </button>
          </div>
        </div>
      );
    }
  }

  renderTrial() {
    var total = global.clientsInactive.length + global.clients.length;
    if (
      this.state.clientsTrial.length > 0 &&
      (total < global.maxClients || global.maxClients === 0)
    ) {
      var list = this.state.clientsTrial;
      list.sort((a, b) => a.data.name.localeCompare(b.data.name));
      return (
        <div className="clear">
          <div className="listheader mt-10">
            <h3>{lang.t("header:title.clientstrial")}</h3>
          </div>
          <div className="clear"></div>
          {list.map((item) => (
            <div className="box list simple highlight mb-10" key={item.id}>
              {this.renderTrialContent(item)}
            </div>
          ))}
        </div>
      );
    }
  }

  renderInactiveDate(item) {
    var label = "";
    for (var note of item.history) {
      if (note.data && note.data.title && note.data.title.toLowerCase().startsWith("inactiv")) {
        label =
          lang.t("clients:label.since") +
          " " +
          Moment(note.data.date, "DD/MM/YYYY HH:mm")
            .locale(lang.language)
            .format("D MMM YYYY");
      }
    }
    return label;
  }

  renderInactive() {
    var total = global.clientsInactive.length + global.clients.length;
    if (
      global.clientsInactive.length > 0 &&
      (total < global.maxClients || global.maxClients === 0) &&
      HelperBusiness.getRoleIncl("trainer")
    ) {
      var list = this.state.clientsInactive;
      list.sort((a, b) => a.data.name.localeCompare(b.data.name));
      if (list.length === 0) {
        return (
          <div className="clear">
            <div className="listheader">
              <div className="lft mt-10">
                <ListHeader id="inactiveclients" number={list.length} />
              </div>
              <input
                type="text"
                className="light search rgt"
                placeholder={lang.t("clients:label.filterbyname")}
                value={this.state.searchInactive}
                onChange={(val) => this.filterClientsInactive(val)}
              />
              <div className="clear"></div>
            </div>
            <div className="clear"></div>
            <ListEmptySearch id="clients" />
          </div>
        );
      } else {
        return (
          <div className="clear">
            <div className="listheader">
              <div className="lft mt-10">
                <ListHeader id="inactiveclients" number={list.length} />
              </div>
              <input
                type="text"
                className="light search rgt"
                placeholder={lang.t("clients:label.filterbyname")}
                value={this.state.searchInactive}
                onChange={(val) => this.filterClientsInactive(val)}
              />
              <div className="clear"></div>
            </div>
            <div className="clear"></div>
            <p className="mb-5"><strong>{lang.t("clients:label.reactivateoption")}</strong></p>
            <select
              className="light mb-10 width-12"
              value={this.state.reactivateOption}
              onChange={(e) => this.setState({ reactivateOption: e.target.value })}
            >
              <option value="">{lang.t("clients:option.selecttimeframe")}</option>
              <option value="all">{lang.t("clients:option.all")}</option>
              <option value="today">{lang.t("clients:option.today")}</option>
              <option value="yesterday">{lang.t("clients:option.yesterday")}</option>
              <option value="week">{lang.t("clients:option.week")}</option>
            </select>
            {this.state.loadingReactivate ? (
              <button className="btn tertiary width-12">
                {lang.t("clients:empty.loading")}
              </button>
            ) : (
              <button
                className="btn tertiary width-12"
                onClick={() => this.activateClients()}
              >
                {lang.t("clients:button.reactivate")}
              </button>
            )}
            <div className="sv-20 clear"></div>
            {list.map((item) => (
              <div className="box list simple highlight mb-10" key={item.id}>
                <Link
                  to={"/clients/" + item.id + "/details"}
                  onClick={() => this.selectClient(item.id)}
                >
                  <div className="col-5">
                    {HelperClients.getImage(item)}
                    <p className="lft ml-10">
                      <strong>{item.data.name}</strong>
                    </p>
                    {HelperClients.getDotBirthday(item)}
                  </div>
                  <div className="col-5 center">
                    <p>
                      {lang.t("clients:label.inactive")}{" "}
                      {this.renderInactiveDate(item)}
                    </p>
                  </div>
                  <div className="col-2">
                    <button className="btn tertiary small rgt">
                      {lang.t("common:button.viewdetails")}
                    </button>
                  </div>
                </Link>
              </div>
            ))}
            <div className="sv-20"></div>
            <button
              className="btn tertiary width-12"
              onClick={() => this.setState({ showModalDelete: true })}
            >
              {lang.t("clients:button.deleteall")}
            </button>
          </div>
        );
      }
    } else if (
      global.clientsInactive.length > 0 &&
      total > global.maxClients &&
      global.maxClients !== 0 &&
      HelperBusiness.getRoleIncl("trainer")
    ) {
      var list2 = this.state.clientsInactive;
      list2.sort((a, b) => a.data.name.localeCompare(b.data.name));
      if (list2.length === 0) {
        return (
          <div className="clear">
            <div className="listheader">
              <div className="lft mt-10">
                <ListHeader id="inactiveclients" number={list.length} />
              </div>
              <input
                type="text"
                className="light search rgt"
                placeholder={lang.t("clients:label.filterbyname")}
                value={this.state.searchInactive}
                onChange={(val) => this.filterClientsInactive(val)}
              />
              <div className="clear"></div>
            </div>
            <div className="clear"></div>
            <ListEmptySearch id="clients" />
          </div>
        );
      } else {
        return (
          <div className="clear">
            <div className="listheader">
              <div className="lft mt-10">
                <ListHeader id="inactiveclients" number={list2.length} />
              </div>
              <input
                type="text"
                className="light search rgt"
                placeholder={lang.t("clients:label.filterbyname")}
                value={this.state.searchInactive}
                onChange={(val) => this.filterClientsInactive(val)}
              />
              <div className="clear"></div>
            </div>
            <div className="clear"></div>
            {list2.map((item) => (
              <div
                className="box list simple highlight mb-10"
                key={item.id}
                style={{ opacity: 0.4 }}
              >
                <Link to={ROUTES.SUBSCRIPTION}>
                  <div className="col-4">
                    {HelperClients.getImage(item)}
                    <p className="lft ml-10">
                      <strong>{item.data.name}</strong>
                    </p>
                    {HelperClients.getDotBirthday(item)}
                  </div>
                  <div className="col-8">
                    <p className="right">
                      {lang.t("clients:label.subscription1")}
                    </p>
                  </div>
                </Link>
              </div>
            ))}
            <div className="sv-40"></div>
            <p className="small center secondary">
              {lang.t("clients:label.subscription2a")} {global.maxClients}{" "}
              {lang.t("clients:label.subscription2b")} {global.maxPrograms}{" "}
              {lang.t("clients:label.subscription2c")}
              <br />
              <Link to={ROUTES.SUBSCRIPTION}>
                {lang.t("clients:button.checkyoursubscriptionnow")}
              </Link>
            </p>
          </div>
        );
      }
    }
  }

  // Content area

  renderBottom() {
    if (this.state.clients.length === 0) {
      if (
        global.clients.length === 0 &&
        this.state.clientsInactive.length === 0 &&
        this.state.clientsTrial.length === 0
      ) {
        return (
          <ListEmpty
            id="clients"
            clickVideo={() => this.setState({ showModalVideo: true })}
          />
        );
      } else {
        return (
          <div className="clear mb-20-992">
            {this.renderListheader()}
            <ListEmptySearch id="clients" />
            <div className="clear"></div>
            {true && (
              <React.Fragment>
                <div className="section mt-20-992 mb-40">
                  <p className="mb-5"><strong>{lang.t("clients:label.deactivateoption")}</strong></p>
                  <select
                    className="light mb-10 width-12"
                    value={this.state.deactivateOption || ""}
                    onChange={(e) => this.setState({ deactivateOption: e.target.value })}
                  >
                    <option value="" style={{color: "#000"}}>{lang.t("clients:option.selectdeactivatetimeframe")}</option>
                    <option value="week" style={{color: "#000"}}>{lang.t("clients:option.week")}</option>
                    <option value="month" style={{color: "#000"}}>{lang.t("clients:option.month")}</option>
                    <option value="custom" style={{color: "#000"}}>{lang.t("clients:option.custom")}</option>
                  </select>
                  {this.state.deactivateOption === "custom" && (
                    <div className="mb-20">
                      <div className="lft width-6 pr-5">
                        <p className="mb-5"><small>{lang.t("clients:label.startdate")}</small></p>
                        <input type="date" className="light" value={this.state.deactivateStartDate || ""} onChange={(e) => this.setState({ deactivateStartDate: e.target.value })} />
                      </div>
                      <div className="lft width-6 pl-5">
                        <p className="mb-5"><small>{lang.t("clients:label.enddate")}</small></p>
                        <input type="date" className="light" value={this.state.deactivateEndDate || ""} onChange={(e) => this.setState({ deactivateEndDate: e.target.value })} />
                      </div>
                      <div className="clear"></div>
                    </div>
                  )}
                  {this.state.loadingDeactivate ? (
                      <button className="btn tertiary width-12 mb-20">
                        {lang.t("clients:empty.loading")}
                      </button>
                  ) : (
                      <button className="btn tertiary width-12 mb-20" onClick={() => this.deactivateInactiveClients()}>
                        {lang.t("clients:button.deactivatebyinactivity")}
                      </button>
                  )}
                </div>
                
                <div className="section mb-40">
                  <p className="mb-5"><strong>{lang.t("clients:label.bulkdeactivate")}</strong></p>
                  <p className="mb-10"><small>{String(lang.t("clients:label.selectedcount") || "{0} members selected").replace("{0}", (this.state.selectedClients || []).length)}</small></p>
                  {this.state.loadingBulkDeactivate ? (
                    <button className="btn tertiary width-12 mb-20">
                      {lang.t("clients:empty.loading")}
                    </button>
                  ) : (
                    <button 
                      className="btn tertiary width-12 mb-20" 
                      onClick={() => this.deactivateSelectedClients()}
                      disabled={!this.state.selectedClients || this.state.selectedClients.length === 0}
                    >
                      {lang.t("clients:button.deactivateselected")}
                    </button>
                  )}
                </div>
              </React.Fragment>
            )}
            {this.renderTrial()}
            {this.renderInactive()}
            <div className="sv-40 clear"></div>
          </div>
        );
      }
    } else {
      return (
        <div>
          <div className="clear mb-20-992"></div>
          {this.renderListheader()}
          {this.renderClients()}
          <div className="clear"></div>
          {true && (
            <React.Fragment>
              <div className="section mt-20-992 mb-40">
                <p className="mb-5"><strong>{lang.t("clients:label.deactivateoption")}</strong></p>
                <select
                  className="light mb-10 width-12"
                  value={this.state.deactivateOption || ""}
                  onChange={(e) => this.setState({ deactivateOption: e.target.value })}
                >
                  <option value="" style={{color: "#000"}}>{lang.t("clients:option.selectdeactivatetimeframe")}</option>
                  <option value="week" style={{color: "#000"}}>{lang.t("clients:option.week")}</option>
                  <option value="month" style={{color: "#000"}}>{lang.t("clients:option.month")}</option>
                  <option value="custom" style={{color: "#000"}}>{lang.t("clients:option.custom")}</option>
                </select>
                {this.state.deactivateOption === "custom" && (
                  <div className="mb-20">
                    <div className="lft width-6 pr-5">
                      <p className="mb-5"><small>{lang.t("clients:label.startdate")}</small></p>
                      <input type="date" className="light" value={this.state.deactivateStartDate || ""} onChange={(e) => this.setState({ deactivateStartDate: e.target.value })} />
                    </div>
                    <div className="lft width-6 pl-5">
                      <p className="mb-5"><small>{lang.t("clients:label.enddate")}</small></p>
                      <input type="date" className="light" value={this.state.deactivateEndDate || ""} onChange={(e) => this.setState({ deactivateEndDate: e.target.value })} />
                    </div>
                    <div className="clear"></div>
                  </div>
                )}
                {this.state.loadingDeactivate ? (
                    <button className="btn tertiary width-12 mb-20">
                      {lang.t("clients:empty.loading")}
                    </button>
                ) : (
                    <button className="btn tertiary width-12 mb-20" onClick={() => this.deactivateInactiveClients()}>
                      {lang.t("clients:button.deactivatebyinactivity")}
                    </button>
                )}
              </div>
              
              <div className="section mb-40">
                <p className="mb-5"><strong>{lang.t("clients:label.bulkdeactivate")}</strong></p>
                <p className="mb-10"><small>{String(lang.t("clients:label.selectedcount") || "{0} members selected").replace("{0}", (this.state.selectedClients || []).length)}</small></p>
                {this.state.loadingBulkDeactivate ? (
                  <button className="btn tertiary width-12 mb-20">
                    {lang.t("clients:empty.loading")}
                  </button>
                ) : (
                  <button 
                    className="btn tertiary width-12 mb-20" 
                    onClick={() => this.deactivateSelectedClients()}
                    disabled={!this.state.selectedClients || this.state.selectedClients.length === 0}
                  >
                    {lang.t("clients:button.deactivateselected")}
                  </button>
                )}
              </div>
            </React.Fragment>
          )}
          {this.renderTrial()}
          {this.renderInactive()}
          <div className="sv-40 clear"></div>
        </div>
      );
    }
  }

  renderActions() {
    var item1 = { id: "newclient", link: "" };
    var item2 = { id: "importclient", link: "" };
    var item3 = { id: "11session", link: ROUTES.NEWSESSION };
    if (HelperBusiness.getRoleIncl("")) {
      if (
        this.state.clients.length < this.state.maxClients ||
        this.state.maxClients === 0
      ) {
        item1 = { id: "newclient", link: ROUTES.NEWCLIENT };
        item2 = { id: "importclient", link: ROUTES.NEWCLIENTIMPORT };
        item3 = { id: "11session", link: ROUTES.NEWSESSION };
        var num = 0;
        for (var cl of global.clients) {
          if (cl.data.uid === "" && cl.data.email !== "") {
            num++;
          }
        }
        if (num > 0 && global.clients.length > 5) {
          item3 = { id: "emailinvites", link: "" };
        }
      }
    } else if (HelperBusiness.getRole("trainer")) {
      item1 = { id: "newclient", link: ROUTES.NEWCLIENT };
      item2 = { id: "session", link: ROUTES.NEWSESSION };
      item3 = "";
    } else if (HelperBusiness.getRole("admin")) {
      item1 = { id: "newclient", link: ROUTES.NEWCLIENT };
      item2 = "";
      item3 = "";
    } else if (HelperBusiness.getRole("cs")) {
      item1 = { id: "report", link: ROUTES.CLIENTSREPORT };
      item2 = "";
      item3 = "";
    }
    if (HelperBusiness.getRoleIncl("trainer,admin,finance,cs")) {
      return (
        <WidgetActions
          item1={item1}
          clickItem1={() => this.setState({ showModalMessage: true })}
          item2={item2}
          clickItem2={() => this.setState({ showModalMessage: true })}
          item3={item3}
          clickItem3={() => this.showModalInvite()}
        />
      );
    }
  }

  renderOverview() {
    if (HelperBusiness.getRoleIncl("trainer,admin,finance,cs")) {
      return (
        <div className="col-9">
          <WidgetOverview
            item1={{
              id: "activeclients",
              value: this.getActiveClients(),
              prev: this.getActiveDifference(),
            }}
            item2={{
              id: "sessions",
              value: Cal.getAmount(
                this.state.sessions,
                this.state.archive,
                "sessions",
                this.state.dateRange,
              ),
              prev: Cal.getDifference(
                this.state.sessions,
                false,
                this.state.dateRange,
                "num",
              ),
            }}
            item3={{
              id: "group",
              value: Cal.getAmount(
                this.state.sessions,
                this.state.archive,
                "group",
                this.state.dateRange,
              ),
              prev: Cal.getDifference(
                this.state.sessions,
                true,
                this.state.dateRange,
                "num",
              ),
            }}
            item4={{
              id: "training",
              value: Cal.getAmount(
                this.state.sessionsTraining,
                this.state.archiveTraining,
                "sessions",
                this.state.dateRange,
              ),
              prev: Cal.getDifference(
                this.state.sessionsTraining,
                false,
                this.state.dateRange,
                "num",
              ),
            }}
          />
        </div>
      );
    }
  }

  render() {
    return (
      <AuthUserContext.Consumer>
        {(authUser) => (
          <div className={"theme-" + global.spaceTheme}>
            <div className="content withtabs">
              {this.renderOverview()}
              {this.renderActions()}
              {this.renderBottom()}
            </div>
            <Tour
              clickVideo={() => this.setState({ showModalVideo: true })}
              type="video"
            />
            <Header
              type="clients"
              active="list"
              selector={true}
              updateSelect={() =>
                this.setState({ dateRange: global.dateRange })
              }
            />
            <Navigation active="clients" />
            <ModalTrial
              type={"list"}
              show={this.state.showModalTrial}
              date={this.state.trialDate}
              onHide={() => this.hideModals()}
              onChange={(event) => this.setState({ trialDate: event })}
              clickMainButton={() => this.updateTrial()}
              clickSecondaryButton={() => this.cancelTrial()}
              clickTertiaryButton={() => this.cancelDeleteTrial()}
            />
            <ModalMessageSimple
              type="clientlimit"
              show={this.state.showModalMessage}
              onHide={() => this.hideModals()}
              clickMainButton={() => this.modalClick()}
              var={global.maxClients}
            />
            <ModalMessageDouble
              type="clientinvite"
              show={this.state.showModalInvite}
              var={this.state.invitees}
              onHide={() => this.hideModals()}
              clickMainButton={() => this.sendInvites()}
              clickSecondaryButton={() => this.hideModals()}
            />
            <ModalItems
              show={this.state.showModalNotes}
              type={"notes"}
              title={lang.t("modals:items.title.clientnotes")}
              items={
                this.state.client === null ? [] : this.state.client.history
              }
              empty={lang.t("modals:items.empty.clientnotes")}
              onHide={() => this.hideModals()}
            />
            <ModalItems
              show={this.state.showModalBookings}
              type={"bookings"}
              title={lang.t("modals:items.title.upcomingsessions")}
              items={this.state.bookings}
              empty={lang.t("modals:items.empty.bookings")}
              onHide={() => this.hideModals()}
            />
            <ModalVideo
              type="overview"
              show={this.state.showModalVideo}
              url="https://youtu.be/BK38WH_A0d0"
              onHide={() => this.hideModals()}
            />
            <ModalMessageSimple
              type="clientinactive"
              show={this.state.showModalDelete}
              onHide={() => this.hideModals()}
              clickMainButton={() => this.deleteInactiveClients()}
              clickSecondaryButton={() => this.hideModals()}
            />
          </div>
        )}
      </AuthUserContext.Consumer>
    );
  }
}

const condition = (authUser) => !!authUser;

export default withTranslation([
  "clients",
  "common",
  "header",
  "overview",
  "modals",
  "messaging",
  "actions",
  "nav",
  "empty",
])(withAuthorization(condition)(ClientsPage));
